import {createStore} from 'redux';

import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import rootReducer from '../reducers'; // the value from combineReducers

const persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: hardSet // see "Merge Process" section for details.
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(pReducer);
export const persistor = persistStore(store);
